// lib/orderTracking/receiptCodeFromUrl.ts
// Módulo NORMAL (sin "server-only"): a diferencia de trackingLink.ts, este lo
// importa un client component (OrderSheet.tsx) además del servidor. Pura
// extracción de texto, sin I/O — separado de trackingLink.ts a propósito
// (ver el comentario ahí) para no arrastrar "server-only" al bundle del cliente.

/** Código de recibo dentro de una URL /p/{código}; null si no es una. */
export function receiptCodeFromTrackingUrl(url: string | null | undefined): string | null {
  const m = /\/p\/([23456789ABCDEFGHJKMNPQRSTVWXYZ]{6})(?:[/?#]|$)/i.exec(url ?? "")
  return m ? m[1].toUpperCase() : null
}
